import React from "react";
import { useSession } from "../utils/Session";
import { useHistory, useParams } from "react-router";
import AccountDetails from "./AccountDetails";
import AccountCreate from "./AccountCreate";
import AccountForgot from "./AccountForgot";
import AccountLoginForm from "./AccountLoginForm";
import { Divider } from "antd";
import AccountSignUp from "./AccountSignUp";
import AccountVerify from "./AccountVerify";
import AccountComplete from "./AccountComplete";

export default function Account() {

    const [session, setSession] = useSession();
    const { view = "details" } = useParams();
    const history = useHistory();


    const displayLogin = () => {
        return (
            <div style={{ "maxWidth": "300px", "margin": "0 auto" }}>
                <h2>Login</h2>
                <div aria-hidden><Divider /></div>
                <div>
                    <AccountLoginForm size="large" show_create={true} />
                </div>
            </div>
        );
    }

    const displayView = () => {

        if (!session.logged_in) {
            switch (view) {
                case "login":
                    return displayLogin();
                case "signup":
                    return (<AccountSignUp />);
                case "forgot":
                    return (<AccountForgot />)
                case "create":
                    return (<AccountCreate />)
                case "verify":
                    return (<AccountVerify />)
                case "activate":
                    return (<AccountForgot activate />)
                //     return (<></>)
                default:
                    return displayLogin()
            }
        } else {
            switch (view) {
                case "details":
                    return (<AccountDetails />);
                case "finished":
                    return (<AccountComplete />)
                default:
                    history.push({ "pathname": "/account/details" });
                    return (<>stuff</>)
            }
        }

    }



    return (
        <div className="container">
            {displayView()}
        </div>

    )
}